import React from 'react'

function Footer() {
  return (
      <div className="copyRight" style={{fontWeight:'600'}}>
        Copyright © 2023 by Himanshu. All rights reserved.
      </div>
  )
}

export default Footer
